<template>
    <div style="padding-top: 100px;">
        <PageContainer>
            <h1 class="text-center mb-6">Your password has been changed</h1>
            <p class="text-center mb-12">
                Please logout and login again to use the app.
            </p>
            <v-row>
                <v-col></v-col>
                <v-col>
                    <v-btn
                        color="secondary"
                        block
                        class="font-weight-regular text-capitalize px-16"
                        @click="sendToLogin"
                    >
                        Logout
                    </v-btn>
                </v-col>
                <v-col></v-col>
            </v-row>
        </PageContainer>
    </div>
</template>

<script>

export default {
    methods: {
        sendToLogin() {
            this.$router.push({ path: "/login" });
        }
    }
}
</script>
